module.exports = __webpack_public_path__ + "img/seminar (19).bc7aa096.jpg";